export const evaluationListLabels = {
  wound: "Wound",
  braden: "Braden",
  purs: "PURS",
  totalSkin: "Total Skin",
  abpi: "ABPI",
  toePressure: "Toe Pressure",
  hba1c: "HbA1c"
};
